// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Padding_wrap_2QEff","input":"Padding_input_3N69f","select":"Padding_select_12W1T","selectItem":"Padding_selectItem_13nXM"};